import {HttpErrorResponse, HttpEvent, HttpHandler, HttpInterceptor, HttpRequest, HttpResponse} from '@angular/common/http';
import {Injectable} from '@angular/core';
import {Observable} from 'rxjs/Observable';
import {AngularFireAuth} from 'angularfire2/auth';
import {fromPromise} from 'rxjs/observable/fromPromise';
import 'rxjs/add/operator/switchMap';
import 'rxjs/add/operator/do';
import {Router} from '@angular/router';

@Injectable()
export class AuthInterceptor implements HttpInterceptor {

  constructor(private router: Router, private afAuth: AngularFireAuth) {
  }

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {

    if (req.url.includes('localhost:9100')) { // 라벨프린터에 전달하는 요청은 그대로 전달
      return next.handle(req);
    }

    return fromPromise(this.afAuth.auth.currentUser.getIdToken(true))
      .switchMap(token => {
        req = req.clone({
          setHeaders: {
            Authorization: `${token}`
          }
        });

        return next.handle(req).do((event: HttpEvent<any>) => {
          if (event instanceof HttpResponse) {
            // do stuff with response if you want
          }
        }, (err: any) => {
          if (err instanceof HttpErrorResponse) {
            if (err.status === 401) {
              this.afAuth.auth.signOut();
              this.router.navigate(['login'], {skipLocationChange: true});
            }
          }
        });
      });
  }

}






// WEBPACK FOOTER //
// D:/projects/feelway-pawnshop/pawnshop-web-client-feelway/src/app/auth.interceptor.ts